import { render } from "./DeliveryGroupCreate.vue?vue&type=template&id=2591797e"
import script from "./DeliveryGroupCreate.vue?vue&type=script&lang=js"
export * from "./DeliveryGroupCreate.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__